import { CommonModule } from '@angular/common';
import { Component, computed, Inject, Optional, Signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { CacheService } from '@app/_services/cache.service';
import { CustomBottomSheetRef } from '@app/_services/custom-bottom-sheet.service';
import { ModalService } from '@app/_services/modal.service';
import { SettingsService } from '@app/_services/settings.service';
import { PolicyType } from '@app/_types/generic.type';
import { SvgComponent } from '../../svg/svg.component';
import { PolicyDialogComponent } from '../policy-dialog/policy-dialog.component';

interface LegalItem {
  type: PolicyType;
  title: string;
}

@Component({
  selector: 'app-legal-dialog',
  imports: [
    CommonModule,
    SvgComponent
  ],
  templateUrl: './legal-dialog.component.html',
  styleUrl: './legal-dialog.component.scss'
})

export class LegalDialogComponent {

  legalItems: Signal<LegalItem[]> = computed(() => {
    return [
      { type: 'PRIVACY_POLICY', title: this.ss.t('common_privacyPolicy') },
      { type: 'TERMS_OF_USE', title: this.ss.t('account_legalInformationTermsOfUse') },
      { type: 'COOKIE_POLICY', title: this.ss.t('cookiesPolicy_title') },
      { type: 'END_USER_LICENSE_AGREEMENT', title: this.ss.t('account_legalInformationEndUserLicenseAgreement') },
      { type: 'DISCLAIMER', title: this.ss.t('account_legalInformationDisclaimer') },
      { type: 'ACCEPTABLE_USE_POLICY', title: this.ss.t('account_legalInformationAcceptableUsePolicy') },
    ];
  });

  constructor(
    public ss: SettingsService,
    public cc: CacheService,
    private modalService: ModalService,
    @Optional() public dialogRef: MatDialogRef<LegalDialogComponent> | null,
    @Optional() public bottomSheetRef: CustomBottomSheetRef<LegalDialogComponent> | null,
    @Optional() @Inject(MAT_DIALOG_DATA) dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) bottomSheetData: any,
  ) {
    dialogRef?.backdropClick().subscribe(() => {
      this.closeDialog();
    });

    bottomSheetRef?.backdropClick().subscribe(() => {
      this.closeDialog();
    });
  }

  openPolicy(policyType: PolicyType) {
    const data = { type: policyType };

    if (this.cc.isNarrowScreen()) {
      this.modalService.openMainContent(
        PolicyDialogComponent,
        data,
        { disableClose: true, autoFocus: false }
      );
    } else {
      this.modalService.openLevel1(
        PolicyDialogComponent,
        data,
        { disableClose: true, autoFocus: false }
      );
    }
  }

  closeDialog() {
    this.close();
  }

  private close(result?: any): void {
    if (this.dialogRef) {
      this.dialogRef.close(result);
    } else if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss(result);
    }
  }
}
